import { alpha } from '@mui/material/styles';

export const WEEK_DAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

export const TICKET_TYPES_MAP = {
  IC: 'Commingled BS',
  LARGE: 'Large BS',
  SUPE: 'Supe BS',
};

export const TICKET_TYPE_ORDER = ['IC', 'LARGE', 'SUPE'];

export const getTicketTypeLabel = (ticketType) => TICKET_TYPES_MAP[ticketType] || ticketType;

export const EDITABLE_WAREHOUSE_AND_INFO_DATA_SCOPES = []; // will add more scopes soon, now allow all scopes to edit

export const WEEK_DAY_NAMES = {
  MON: 'Monday',
  TUE: 'Tuesday',
  WED: 'Wednesday',
  THU: 'Thursday',
  FRI: 'Friday',
  SAT: 'Saturday',
  SUN: 'Sunday',
};

// Background of a cell with unsaved changes (Forecast Table + Auto Forecast Settings)
export const getChangedCellBgColor = (theme) => alpha(theme.palette.primary.main, 0.15);
